import { useQuery, useMutation } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';

export function useSessionMatchResults(sessionId: string) {
  const data = useQuery(
    api.coach.matchResults.getForSession,
    sessionId ? { sessionId: sessionId as Id<"trainingSessions"> } : 'skip'
  );
  return { data: data ?? [], isLoading: data === undefined };
}

export function useUpsertMatchResult() {
  const mutate = useMutation(api.coach.matchResults.upsert);
  return {
    mutateAsync: (args: {
      sessionId: string;
      playerId: string;
      opponentName: string;
      opponentPlayerId?: string;
      score?: string;
      outcome?: 'win' | 'loss';
    }) =>
      mutate({
        sessionId: args.sessionId as Id<"trainingSessions">,
        playerId: args.playerId as Id<"players">,
        opponentName: args.opponentName,
        opponentPlayerId: args.opponentPlayerId as Id<"players"> | undefined,
        score: args.score,
        outcome: args.outcome,
      }),
  };
}

export function useUpdateMatchScore() {
  const mutate = useMutation(api.coach.matchResults.updateScore);
  return {
    mutateAsync: (args: {
      resultId: string;
      score: string;
      outcome: 'win' | 'loss';
    }) =>
      mutate({
        resultId: args.resultId as Id<"sessionMatchResults">,
        score: args.score,
        outcome: args.outcome,
      }),
  };
}

export function useDeleteMatchResult() {
  const mutate = useMutation(api.coach.matchResults.remove);
  return {
    mutateAsync: (resultId: string) =>
      mutate({ resultId: resultId as Id<"sessionMatchResults"> }),
  };
}
